import { Outlet, createFileRoute } from "@tanstack/react-router";

/**
 * The `/plugins` segment, and nothing more.
 *
 * This used to read `useLocation()` and return a different page component per
 * pathname, which meant the router only ever knew about one plugins route. The
 * view switcher therefore had nowhere to link and fell back to plain anchors,
 * so every tab change was a full document load. Each page is a registered
 * child route now; this one just renders whichever matched.
 */
export const Route = createFileRoute("/_chat/plugins")({
  component: Outlet,
});
